import { useLayoutEffect } from "react";
import { Navigate } from "react-router-dom";
import { useLoginRedirect } from "../../hooks/settingHooks";

interface Props {
  config: string;
  reset: () => void;
}

export function NavigateToLogin(props: Props) {
  const { config, reset } = props;
  const redirectPath = useLoginRedirect(config);

  useLayoutEffect(reset);

  return <Navigate to={redirectPath} />;
}
